module.exports = __webpack_public_path__ + "passe.gif?029b17d397880674800d2a6637a8a241";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/passe.gif
// module id = 140
// module chunks = 0